import { defineField } from '@/form/useForm'
import { EAssetSource, EAssetType, type FullInvestment, type IProviderImport } from 'findef'
import { lockedByIr, lockedByProvider } from '../toolips'
import type { UseAssetFormComputedData } from '../types'

const NOW = new Date()
export const timeInvestedField = () => {
  return defineField<FullInvestment, Date, UseAssetFormComputedData>({
    type: 'date',
    value: NOW,
    label: 'Investment Date',
    required: true,
    tooltip: 'Select a representative date for the total investment in this asset',
    needs: ['asset.type', 'asset.source', 'providerImport'],
    next: (state) => {
      const providerImport = state.asset.providerImport as IProviderImport | null | undefined
      const label = state.asset.type === EAssetType.CASH ? 'Deposit Date' : 'Investment Date'
      const tooltip = state.asset.type === EAssetType.CASH
        ? 'Select a representative date for when the cash was deposited'
        : 'Select a representative date for the total investment in this asset'
      return {
        label,
        value: state.time,
        tooltip,
        locked: state.asset.source === EAssetSource.IR || !!state.providerImport,
        ...(state.asset.source === EAssetSource.IR
          ? lockedByIr(state)
          : providerImport
            ? lockedByProvider(state)
            : {
                lockedReason: 'This field is maintained by another source'
              })
      }
    }
  })
}
